import { render, staticRenderFns } from "./RejectedPayments.vue?vue&type=template&id=8389859a"
import script from "./RejectedPayments.vue?vue&type=script&lang=js"
export * from "./RejectedPayments.vue?vue&type=script&lang=js"
import style0 from "./RejectedPayments.vue?vue&type=style&index=0&id=8389859a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports